// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__13Uyf","link":"Navigation_link__2rKAR","linkActive":"Navigation_linkActive__kThqt"};